import { render, staticRenderFns } from "./PlaylistWidget.vue?vue&type=template&id=5685b307&scoped=true"
import script from "./PlaylistWidget.vue?vue&type=script&lang=js"
export * from "./PlaylistWidget.vue?vue&type=script&lang=js"
import style0 from "./PlaylistWidget.vue?vue&type=style&index=0&id=5685b307&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5685b307",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5685b307')) {
      api.createRecord('5685b307', component.options)
    } else {
      api.reload('5685b307', component.options)
    }
    module.hot.accept("./PlaylistWidget.vue?vue&type=template&id=5685b307&scoped=true", function () {
      api.rerender('5685b307', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/playerWidgets/PlaylistWidget.vue"
export default component.exports